module.exports = __webpack_public_path__ + "static/media/globe.daa5e391.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/globe.svg
// module id = 1544
// module chunks = 0